'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { CategoriesShowcaseV2 } from '@src/SectionRenderer/sections/categoriesShowcaseV2/CategoriesShowcaseV2'

import { buildCategoriesShowcaseConfig } from '../categories-showcase-section-builders'

import type { CategoriesShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const CategoriesShowcaseWidgetComponent = (props: PLTypedWidgetProps<CategoriesShowcaseWidgetData>) => {
  const data = props.data.categoriesShowcaseData
  if (!data) return null
  if (!data.thumbnails.length) return null

  return <CategoriesShowcaseV2 sectionConfig={buildCategoriesShowcaseConfig(data)} />
}

export const CategoriesShowcaseWidget: PLTypedWidgetInterface<
  CategoriesShowcaseWidgetData,
  WidgetType.CATEGORIES_SHOWCASE
> = {
  id: WidgetType.CATEGORIES_SHOWCASE,
  errorBoundary: PLBaseErrorBoundary,
  render: CategoriesShowcaseWidgetComponent,
}
